export const COMPONENT_NAME = "wallet-pattern";
